
























































































































































































































































































































































































































































































import {
  BButton,
  BCard,
  BCol,
  BFormInput,
  BRow,
  BFormGroup,
  BFormTextarea,
  BFormCheckbox,
  BFormRadioGroup,
  BInputGroupPrepend,
  BInputGroup,
  VBTooltip,
  BTooltip,
  BFormDatepicker,
} from "bootstrap-vue";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { InformationOperationnelle } from "@/api/models/informationsOperationnelles/informationOperationnelle";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormGroup,
    SearchableVueSelect,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    BFormCheckbox,
    BFormRadioGroup,
    BInputGroupPrepend,
    BInputGroup,
    FeatherIcon,
    BTooltip,
    BFormDatepicker
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
})
export default class InfosOperationnellesUtilisateur extends Vue {
  @Prop({ required: true }) utilisateurId!: string;

  infosOperationnelle: any = null;
  infosOperationnelleRES: any[] = [];
  oldInfosOperationnelleRES: any[] = [];
  infosOperationnelleString: any = "";
  listInfo: InformationOperationnelle[] = [];
  indexOfInfo = 0;
  refreshIndex = 0;

  async created() {
    await this.getInfosOperationnelles(
      "myressif_user_operationnal_metadatas_structure"
    );
    if (this.infosOperationnelle) {
      Object.keys(this.infosOperationnelle).forEach(async (x: any) => {
        this.indexOfInfo++;
        if (
          this.infosOperationnelle[x].Type == "Choice" ||
          this.infosOperationnelle[x].Type == "ChoiceMultiple"
        ) {
          await this.getInfosOperationnelles(this.infosOperationnelle[x].TypeKey);
        }
      });
    }

    await this.getInfosOperationnellesData();
    await this.getOldInfosOperationnellesData();
  }

  async getInfosOperationnelles(parametre: any) {
    await this.$http.myressif.parametres
      .getByNom(parametre)
      .then(async (res: InformationOperationnelle) => {
        if (parametre == "myressif_user_operationnal_metadatas_structure") {
          this.infosOperationnelle = res ? JSON.parse(res.valeur) : [];
        } else {
          try {
            this.listInfo[parametre] = res ? 
              //@ts-ignore
              JSON.parse(res.valeur)?.sort(function (a: string, b: string) {
                return a.toLowerCase().localeCompare(b.toLowerCase());
              }) : [];
          }
          catch(ex: any) {
            console.log('Error parsing parameter:', ex);
          }
        }
      })
      .catch((error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      });
  }

  async getInfosOperationnellesData() {
    await this.$http.myressif.utilisateurs
      .getListInformationOperationnelleByUtilisateurId(this.utilisateurId)
      .then((res: any) => {
        this.infosOperationnelleRES = res
          ? JSON.parse(JSON.stringify(res))
          : [];
        setTimeout(() => {
          this.refreshIndex++;
        }, 1000);
      })
      .catch((error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      });
  }

  async getOldInfosOperationnellesData() {
    await this.$http.myressif.utilisateurs
      .getListOldInformationOperationnelleByUtilisateurId(this.utilisateurId)
      .then((res: any) => {
        this.oldInfosOperationnelleRES = res
          ? JSON.parse(JSON.stringify(res))
          : [];
        setTimeout(() => {
          this.refreshIndex++;
        }, 1000);
      })
      .catch((error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      });
  }

  async submit() {
    await this.$http.myressif.utilisateurs
      .updateInformationOperationnelle(
        this.utilisateurId,
        JSON.stringify(this.infosOperationnelleRES)
      )
      .then(
        async () => {
          successAlert.fire({
            timer: 3500,
            title: "Modification des informations opérationnelles",
            text: "Informations opérationnelles modifiées avec succès",
          });
          await this.getOldInfosOperationnellesData();
        }
      )
      .catch((error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      });
  }
}
